<template>
    <form class="boxForm_step4" @submit.prevent="onSubmit">
      <div class="groupInput contact-form">
        <BaseInput
          ref="input"
          @focus="onInputClick(true)"
          @blur="onInputClick(false)"
          :mask="'#'.repeat(11)"
          :placeholder="$t('qic_user_qid_placeholder')"
          :validation="$v.passport_"
          :value="value"
          @input="$emit('input', $event)"
          inputMode="numeric"
          inputStyle="big"
        >
          <template v-if="errors.includes('minLength')" v-slot:invalid-input-error>
            {{ $t('qic_user_qid_error') }}
          </template>
          <template v-slot:empty-input-error>
            {{ $t('qic.error.fill_field') }}
          </template>
        </BaseInput>
      </div>
      <BaseButton/>
      <Reminder v-if="!offReminder"/>
      <BaseIstimara
        :desc="$t('qic_user_qid_explain')"
        :img-en="require('@/assets/images/QID.png')"
        :img-ar="require('@/assets/images/QID.png')"/>
    </form>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { BaseIstimara, Reminder, BaseInput, BaseButton } from 'qic-components'
import { trackEvent, trackGtag } from '@/utils/useGtag'

export default {
  name: 'UserIdForm',
  components: {
    BaseIstimara,
    Reminder,
    BaseInput,
    BaseButton
  },
  emits: [
    'onSubmit'
  ],
  props: {
    value: String,
    offReminder: { type: Boolean, default: false }
  },
  data () {
    return {
      placeholder: ' '
    }
  },
  computed: {
    passport_ () {
      return this.value
    },
    errors () {
      return Object.entries(this.$v.passport_)
        .filter(([key, value]) => !key.startsWith('$') && !value)
        .map(([key, _value]) => key)
    }
  },
  methods: {
    trackErrors () {
      this.errors.forEach((error) => {
        trackGtag('error', { label: error })
        trackGtag('input_error', { label: error, qid_number: JSON.stringify({ value: this.value, error }), url: window.location.href, qid: this.value })
      })
    },
    onSubmit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$v.passport_.$touch()
        this.trackErrors()
        return
      }
      this.$emit('onSubmit')
    },
    onInputClick (focused) {
      const children = this.$refs.input.$el.children
      const input = [...children].find(child => child.nodeName === 'INPUT')
      if (focused) {
        input.placeholder = '_'.repeat(11)
      } else {
        input.placeholder = ' '
        const passport = this.passport_.length.toString()
        if (passport) {
          trackEvent('typeQatarID', passport)
        }
      }
    }
  },
  validations () {
    return {
      passport_: {
        required,
        // validFormat: val => /\d{11}$/.test(val),
        validFormat: val => /^[123]/.test(val),
        lengthConstraint: (val) => {
          return String(val).length === 8 || String(val).length === 11
        }
      }
    }
  }
}
</script>
